import { Outlet } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import Footer from "../components/common/Footer.jsx";

const AppLayout = () => {
  return (
    <div className="app-layout">
      <Header />

      <main className="page">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default AppLayout;
